import { SearchField, type SearchFieldProps } from "$components/search-field";
import { path } from "ramda";
import { useCallback, useRef } from "react";
import { type FieldError, useFormContext, useWatch } from "react-hook-form";

const RHFSearchField = ({ name, ...props }: SearchFieldProps) => {
  const inputRef = useRef(null);
  const {
    control,
    setValue,
    getValues,
    register,
    formState: { errors, touchedFields },
  } = useFormContext();

  const defaultValue = getValues(name);
  const value = useWatch({ control, name });

  const touched = path(name.split("."), touchedFields);
  const error = path(name.split("."), errors) as FieldError;

  const errStr = touched ? error?.message : null;
  const { ref, ...field } = register(name);

  const handleClear = useCallback(() => {
    setValue(name, "");
    inputRef.current.focus();
  }, [name, setValue]);

  const handleRef = useCallback(
    (e) => {
      ref(e); // Set RHF ref
      inputRef.current = e; // Set local ref
    },
    [ref],
  );

  return (
    <SearchField
      {...props}
      {...field}
      defaultValue={defaultValue}
      error={errStr}
      value={value}
      onClear={handleClear}
      ref={handleRef}
    />
  );
};

export default RHFSearchField;
